var _path, _g, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBeatMaster(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "beat master"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3245_25867",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 26,
    height: 28
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector 464",
    d: "M16.5 23.5L13 28L1 28.9995V12.9995V6.49952V3.5L1 1H27V10.5H23C22.0316 11.4778 22.0965 14.2778 22.5 15.5L17.5 18.5C15.0789 16.0555 11.5 18 11 18.5L16.5 23.5Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3245_25867)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 2C8.55228 2 9 2.44772 9 3V4H19V3C19 2.44772 19.4477 2 20 2C20.5523 2 21 2.44772 21 3V4H24C25.1046 4 26 4.89543 26 6V26C26 27.1046 25.1046 28 24 28H4C2.89543 28 2 27.1046 2 26V6C2 4.89543 2.89543 4 4 4H7V3C7 2.44772 7.44772 2 8 2ZM7 6H4V10H24V6H21V7C21 7.55228 20.5523 8 20 8C19.4477 8 19 7.55228 19 7V6H9V7C9 7.55228 8.55228 8 8 8C7.44772 8 7 7.55228 7 7V6ZM24 12H4V26H24V12Z",
    fill: "#121212"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00001 1.59961C8.7732 1.59961 9.40001 2.22641 9.40001 2.99961V3.59961H18.6V2.99961C18.6 2.22641 19.2268 1.59961 20 1.59961C20.7732 1.59961 21.4 2.22641 21.4 2.99961V3.59961H24C25.3255 3.59961 26.4 4.67413 26.4 5.99961V25.9996C26.4 27.3251 25.3255 28.3996 24 28.3996H4.00001C2.67452 28.3996 1.60001 27.3251 1.60001 25.9996V5.99961C1.60001 4.67413 2.67452 3.59961 4.00001 3.59961H6.60001V2.99961C6.60001 2.22641 7.22681 1.59961 8.00001 1.59961ZM6.60001 6.39961H4.40001V9.59961H23.6V6.39961H21.4V6.99961C21.4 7.77281 20.7732 8.39961 20 8.39961C19.2268 8.39961 18.6 7.77281 18.6 6.99961V6.39961H9.40001V6.99961C9.40001 7.77281 8.7732 8.39961 8.00001 8.39961C7.22681 8.39961 6.60001 7.77281 6.60001 6.99961V6.39961ZM23.6 12.3996H4.40001V25.5996H23.6V12.3996ZM9.00001 2.99961C9.00001 2.44732 8.55229 1.99961 8.00001 1.99961C7.44772 1.99961 7.00001 2.44732 7.00001 2.99961V3.99961H4.00001C2.89544 3.99961 2.00001 4.89504 2.00001 5.99961V25.9996C2.00001 27.1042 2.89544 27.9996 4.00001 27.9996H24C25.1046 27.9996 26 27.1042 26 25.9996V5.99961C26 4.89504 25.1046 3.99961 24 3.99961H21V2.99961C21 2.44732 20.5523 1.99961 20 1.99961C19.4477 1.99961 19 2.44732 19 2.99961V3.99961H9.00001V2.99961ZM7.00001 5.99961V6.99961C7.00001 7.55189 7.44772 7.99961 8.00001 7.99961C8.55229 7.99961 9.00001 7.55189 9.00001 6.99961V5.99961H19V6.99961C19 7.55189 19.4477 7.99961 20 7.99961C20.5523 7.99961 21 7.55189 21 6.99961V5.99961H24V9.99961H4.00001V5.99961H7.00001ZM24 11.9996V25.9996H4.00001V11.9996H24Z",
    fill: "#121212"
  })))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 465",
    d: "M18.5 23.4999L13.5 29.9999L20 25L25 30C26.2 28 24.8333 25.8333 24 25L28 19.4999C30 20.2999 31.5 19.8333 32 19.4999L24.5 12C23.7 12.8 24.1667 15 24.5 16L18.5 19.4999C16.5 17.4999 14 17.9999 13 18.4999L18.5 23.4999Z",
    fill: "#121212"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeatMaster);
export default __webpack_public_path__ + "static/media/beat-master.cfd65cd98b44d5bec658c11c60f2e1fa.svg";
export { ForwardRef as ReactComponent };